module.exports = __webpack_public_path__ + "img/zhiwen-4.448fdc58.png";